import { ONE_SECOND } from '@main/utils';

export const TOAST_CLASS = 'transcend-toast';
export const TOAST_SUCCESS_DURATION = 5 * ONE_SECOND;
export const TOAST_ERROR_DURATION = 8 * ONE_SECOND;
